export const ACTION_TYPES = {
  GET_APP_DATA_CONF: 'rules/GET_APP_DATA_CONF',
  GET_DATA_VIEW: 'rules/GET_DATA_VIEW',
};